var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { OnDestroy, OnInit } from "@angular/core";
import { MdDialog, MdDialogRef } from "@angular/material";
import { Store } from "@ngrx/store";
import { PictureSetService } from "../../services/pictureSet.service";
import { SuccessComponent } from "../success/success.component";
import { EventArticlePictureRequest } from "../../models/eventArticlePictureRequest";
import { EventArticleService } from "../../services/event-article.service";
import { eventAdditionalPictureRequest } from "../../models/eventAdditionalPictureRequest";
import { LanguageService } from "../../services/language.service";
import { finalize } from "rxjs/operators";
var LanguagePicture = /** @class */ (function () {
    function LanguagePicture() {
    }
    return LanguagePicture;
}());
export { LanguagePicture };
var EventMaxMultilingualModalComponent = /** @class */ (function () {
    function EventMaxMultilingualModalComponent(data, dialogRef, mdDialog, store, pictureSetService, eventArticleService, langageService) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.mdDialog = mdDialog;
        this.store = store;
        this.pictureSetService = pictureSetService;
        this.eventArticleService = eventArticleService;
        this.langageService = langageService;
        this.pictureSetUpdated = false;
        this.checkBox = false;
        this.languageChecked = [];
        this.loading = true;
        this.subscriptions = [];
        this.languages = [];
    }
    EventMaxMultilingualModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.selectedPictureSet = new LanguagePicture();
        this.getUserState();
        this.subscriptions.push(this.store
            .select("eventArticlesState")
            .subscribe(function (eventArticleState) {
            _this.loading = true;
            _this.eventArticle = Object.assign({}, eventArticleState.currentEventArticle);
        }));
        this.langageService
            .getAllLanguages()
            .pipe(finalize(function () {
            _this.pictureSet = _this.pictureSetService.getPictureSet();
            _this.getEventAdditionalsPicture();
            _this.selectedPictureSet.languageId =
                _this.currentUser.currentLanguage.id;
            _this.selectedPictureSet.language =
                _this.currentUser.currentLanguage.value;
            _this.selectedPictureSet.originalPicture =
                _this.pictureSet.pictures[0].pictureURL;
            _this.selectedPictureSet.cropPicture =
                _this.pictureSet.pictures[1].pictureURL;
            _this.selectedPictureSet.originalPictureId =
                _this.pictureSet.pictures[0].pictureId;
            _this.selectedPictureSet.cropPictureId =
                _this.pictureSet.pictures[1].pictureId;
            _this.selectedPictureSet.format =
                _this.pictureSet.pictures[1].pictureFormatCode;
            _this.selectedPictureSet.formatId =
                _this.pictureSet.pictures[1].pictureFormatId;
            _this.loading = false;
        }))
            .subscribe(function (languages) {
            _this.languages = languages;
        });
    };
    EventMaxMultilingualModalComponent.prototype.getUserState = function () {
        var _this = this;
        this.subscriptions.push(this.store.select("userState").subscribe(function (user) {
            if (user && user.currentLanguage) {
                _this.currentUser = user;
            }
        }));
    };
    EventMaxMultilingualModalComponent.prototype.getEventAdditionalsPicture = function () {
        var _this = this;
        var request = new EventArticlePictureRequest({
            SportingEventId: this.eventArticle.id,
            SetId: this.pictureSet.setId,
            LanIds: this.languages.map(function (l) { return l.id; }),
        });
        this.eventArticleService
            .getEventAdditionalsPicture(request)
            .subscribe(function (pictures) {
            _this.additionalPicture = pictures;
            _this.languages.forEach(function (lang) {
                var alreadyExists = _this.additionalPicture.some(function (p) { return p.languageId === lang.id; });
                if (!alreadyExists) {
                    _this.additionalPicture.push({
                        languageId: lang.id,
                        languageName: "",
                        originalPictureId: 0,
                        originalPictureURL: "",
                        cropPictureId: 0,
                        cropPictureURL: "",
                        pictureFormatId: 0,
                        checked: false,
                        duplicate: false,
                    });
                }
            });
            _this.additionalPicture = _this.additionalPicture.filter(function (p) { return p.languageId !== _this.currentUser.currentLanguage.id; });
            _this.additionalPicture = _this.additionalPicture.map(function (p) {
                var matchingLanguage = _this.languages.find(function (lang) { return lang.id === p.languageId; });
                return __assign({}, p, { languageName: matchingLanguage.value });
            });
            _this.initAdditionalPicture = JSON.parse(JSON.stringify(_this.additionalPicture));
        });
    };
    EventMaxMultilingualModalComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    EventMaxMultilingualModalComponent.prototype.getPictureSourceByFormat = function (pictures, formatName) {
        return (this.getPictureByFormat(pictures, formatName).pictureURL ||
            this.getPictureByFormat(pictures, formatName).blob);
    };
    EventMaxMultilingualModalComponent.prototype.getPictureByFormat = function (pictures, formatName) {
        if (pictures && Array.isArray(pictures))
            return pictures.find(function (ps) { return ps.pictureFormatName === formatName; });
        return null;
    };
    EventMaxMultilingualModalComponent.prototype.duplicatePicture = function () {
        var _this = this;
        this.additionalPicture.forEach(function (p) {
            p.cropPictureId = _this.pictureSet.pictures[1].pictureId;
            p.cropPictureURL = _this.pictureSet.pictures[1].pictureURL;
            p.originalPictureId = _this.pictureSet.pictures[0].pictureId;
            p.originalPictureURL = _this.pictureSet.pictures[0].pictureURL;
            p.pictureFormatId = _this.pictureSet.pictures[1].pictureFormatId;
        });
        this.pictureSetUpdated = true;
    };
    EventMaxMultilingualModalComponent.prototype.duplicateEmptyPicture = function (picture) {
        var _this = this;
        picture.checked = true;
        picture.duplicate = true;
        this.additionalPicture.forEach(function (p) {
            if (p.languageId == picture.languageId) {
                p.cropPictureId = _this.pictureSet.pictures[1].pictureId;
                p.cropPictureURL = _this.pictureSet.pictures[1].pictureURL;
                p.originalPictureId = _this.pictureSet.pictures[0].pictureId;
                p.originalPictureURL = _this.pictureSet.pictures[0].pictureURL;
                p.pictureFormatId = _this.pictureSet.pictures[1].pictureFormatId;
            }
        });
        this.pictureSetUpdated = true;
    };
    EventMaxMultilingualModalComponent.prototype.duplicateToEmpty = function () {
        var _this = this;
        this.additionalPicture.forEach(function (p) {
            if (p.originalPictureId == 0 && p.cropPictureId == 0) {
                p.cropPictureId = _this.pictureSet.pictures[1].pictureId;
                p.cropPictureURL = _this.pictureSet.pictures[1].pictureURL;
                p.originalPictureId = _this.pictureSet.pictures[0].pictureId;
                p.originalPictureURL = _this.pictureSet.pictures[0].pictureURL;
                p.pictureFormatId = _this.pictureSet.pictures[1].pictureFormatId;
            }
        });
        this.pictureSetUpdated = true;
    };
    EventMaxMultilingualModalComponent.prototype.copyPicture = function (duplicateType) {
        var _this = this;
        this.checkBox = true;
        this.pictureSetUpdated = false;
        if (duplicateType == 1) {
            this.additionalPicture.forEach(function (p) {
                p.cropPictureId = _this.pictureSet.pictures[1].pictureId;
                p.cropPictureURL = _this.pictureSet.pictures[1].pictureURL;
                p.originalPictureId = _this.pictureSet.pictures[0].pictureId;
                p.originalPictureURL = _this.pictureSet.pictures[0].pictureURL;
                p.pictureFormatId = _this.pictureSet.pictures[1].pictureFormatId;
                p.checked = true;
            });
        }
        if (duplicateType == 2) {
            this.additionalPicture.forEach(function (p) {
                if (p.cropPictureId == 0) {
                    p.cropPictureId = _this.pictureSet.pictures[1].pictureId;
                    p.cropPictureURL = _this.pictureSet.pictures[1].pictureURL;
                    p.originalPictureId = _this.pictureSet.pictures[0].pictureId;
                    p.originalPictureURL = _this.pictureSet.pictures[0].pictureURL;
                    p.pictureFormatId = _this.pictureSet.pictures[1].pictureFormatId;
                    p.checked = true;
                }
            });
        }
        if (duplicateType == 3) {
            this.additionalPicture.forEach(function (p) {
                p.checked = false;
            });
        }
    };
    EventMaxMultilingualModalComponent.prototype.cancelDuplicatePicture = function () {
        this.checkBox = false;
        this.additionalPicture = JSON.parse(JSON.stringify(this.initAdditionalPicture));
    };
    EventMaxMultilingualModalComponent.prototype.checkDuplicatePicture = function (picture, event) {
        var _this = this;
        if (event.checked == true) {
            this.additionalPicture.forEach(function (p) {
                if (p.languageId == picture.languageId) {
                    p.cropPictureId = _this.pictureSet.pictures[1].pictureId;
                    p.cropPictureURL = _this.pictureSet.pictures[1].pictureURL;
                    p.originalPictureId = _this.pictureSet.pictures[0].pictureId;
                    p.originalPictureURL = _this.pictureSet.pictures[0].pictureURL;
                    p.pictureFormatId = _this.pictureSet.pictures[1].pictureFormatId;
                }
            });
        }
        else {
            this.additionalPicture.forEach(function (p) {
                if (p.languageId == picture.languageId) {
                    p.cropPictureId = 0;
                    p.cropPictureURL = "";
                    p.originalPictureId = 0;
                    p.originalPictureURL = "";
                    p.pictureFormatId = 0;
                    p.checked = false;
                }
            });
        }
    };
    EventMaxMultilingualModalComponent.prototype.applyDuplicatePicture = function () {
        this.checkBox = false;
        this.pictureSetUpdated = true;
        this.additionalPicture.forEach(function (picture) {
            picture.duplicate = false;
        });
        this.initAdditionalPicture = JSON.parse(JSON.stringify(this.additionalPicture));
    };
    EventMaxMultilingualModalComponent.prototype.save = function () {
        var _this = this;
        this.pictureSetUpdated = false;
        this.loading = true;
        var additionalPictureToSave = this.additionalPicture.filter(function (additionalPicture) {
            return additionalPicture.cropPictureId !== 0 &&
                additionalPicture.originalPictureId !== 0;
        });
        var request = new eventAdditionalPictureRequest({
            sportingEventId: this.eventArticle.id,
            languageId: this.currentUser.currentLanguage.id,
            setId: this.pictureSet.setId,
            additionalPicture: additionalPictureToSave,
            userId: this.currentUser.id
        });
        this.eventArticleService
            .saveEventMaxAdditionalsPicture(request)
            .subscribe(function (res) {
            if (res.success == 1) {
                _this.close();
                _this.loading = false;
                _this.mdDialog.open(SuccessComponent, {
                    data: { message: "Additionals picture have been updated." },
                });
            }
            else {
                _this.loading = false;
            }
        });
    };
    EventMaxMultilingualModalComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    return EventMaxMultilingualModalComponent;
}());
export { EventMaxMultilingualModalComponent };



// WEBPACK FOOTER //
// ./src/app/modals/event-max-multilingual-modal/event-max-multilingual-modal.component.ts.pre-build-optimizer.js